import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const SignupPage = () => {

    const navigate = useNavigate();

    const [state, setState] = useState({
        name: '',
        email: '',
        password: ''
    });

    const updateState = e => setState({
        ...state,
        [e.target.name]: e.target.value
    });

    const onFormSubmit = e => {
        e.preventDefault();
        console.log(state);
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/signup`, {
            name: state.name,
            email: state.email,
            password: state.password
        })
        .then(axiosResponse => {
            console.log(axiosResponse.data);
            navigate('/login');
        })
        .catch(err => console.log(err));
    }

    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
        setPasswordShown(!passwordShown);
    };

    return (
        <div className="authContainer">
            <h1>Sign Up</h1>

            <div className="authForm">
                <form onSubmit={onFormSubmit} className="authBttn">
                    {/* <label>Name</label><br /> */}
                    <i class="fa fa-user icon"></i>
                    <input value={state.name} name="name" onChange={updateState} />
                <br />
                    {/* <label>Email</label><br /> */}
                    <i class="fa fa-envelope icon"></i>
                    <input value={state.email} name="email" onChange={updateState} />
                <br />
                    {/* <label>Password</label><br />
                    <input value={state.password} name="password"  onChange={updateState} />
                <br />
                <br /> */}

                <i className="fa fa-lock icon "></i>
                <input value={state.password} 

                type={passwordShown ? "text" : "password"} 
                
                name="password" onChange={updateState} />
                <i class="far fa-eye" id="togglePassword" onClick={togglePassword}></i>
                
                    <button className="authBttn">Submit</button>
                </form>
            </div>

            <p>
                Already have an account? Log in <a href="/login">here</a>.
            </p>
        </div>
    );
}

export default SignupPage;